export default {
  data() {
    return {
    };
  },
  methods: {
    sanitizeValue(value) {
      return (value) ? this.sanitize(value) : '';
    },
  },
  props: ['tableSettings', 'items'],
  template: `<div class="data-table">
    <table>
        <thead>
            <tr>
                <td v-for="(heading, index) in tableSettings.headings" v-bind:key="index">
                  {{ heading }}
                </td>
            </tr>
        </thead>
        <tbody>
            <router-link  v-for="(item, index) in items" 
                          v-bind:key="item" 
                          class="data-table-row shadow clickable"
                          tag="tr"
                          v-bind:to="tableSettings.keys[tableSettings.keys.length - 1](item)"
                          :key="index">
                <td v-for="(heading, index) in tableSettings.headings" v-bind:key="index" 
                v-html="sanitizeValue(item[tableSettings.keys[index]] ?  
                        item[tableSettings.keys[index]] : tableSettings.keys[index](item))">
                </td>
            </router-link>
        </tbody>
    </table>
</div>`,
};



// WEBPACK FOOTER //
// ./src/components/DataTable.js